// src/components/Patient/advantages.tsx
"use client"

import SectionTwo from "./Sections/SectionTwo"
import classNames from "classnames"
import styles from "../../../styles/LandingPage/Patients.module.scss"
import StyledText from "../../typography/typography-component"
import skColors from "../../../styles/skColors"
import Image from "next/image"
import { useTranslations } from "next-intl"

const Advantages = ({}) => {
  const t = useTranslations("index")

  const items = [
    {
      key: "established",
      img: "/svg/advantages/1.svg",
      title: t("advantages.items.established.title"),
      desc: t("advantages.items.established.desc"),
    },
    {
      key: "comfort",
      img: "/svg/advantages/2.svg",
      title: t("advantages.items.comfort.title"),
      desc: t("advantages.items.comfort.desc"),
    },
    {
      key: "proven",
      img: "/svg/advantages/3.svg",
      title: t("advantages.items.proven.title"),
      desc: t("advantages.items.proven.desc"),
    },
    {
      key: "noInjections",
      img: "/svg/advantages/4.svg",
      title: t("advantages.items.noInjections.title"),
      desc: t("advantages.items.noInjections.desc"),
    },
  ]

  return (
    <SectionTwo>
      <div className={classNames(styles.row, styles.spaceAround, styles.sectionTwoTitle)}>
        <StyledText variant={"h2"} color={skColors.turquoise[600]}>
          {t("advantages.heading")}
        </StyledText>
      </div>

      <div className={classNames(styles.advantageCardsContainer, styles.row, styles.flwr)}>
        {items.map((item) => (
          <div key={item.key} className={styles.smallImageCol}>
            <div className={styles.smallImageContainer}>
              <Image
                src={item.img}
                width={160}
                height={160}
                alt={item.title || item.key}
                style={{
                  maxWidth: "100%",
                  height: "auto",
                }}
              />
            </div>

            <StyledText
              variant={"tags"}
              color={skColors.turquoise[600]}
              style={{
                textTransform: "uppercase",
              }}
            >
              {item.title}
            </StyledText>

            <StyledText
              variant={"pLarge"}
              style={{
                textAlign: "center",
                fontSize: "18px",
              }}
            >
              {item.desc}
            </StyledText>
          </div>
        ))}
      </div>
    </SectionTwo>
  )
}
export default Advantages
